import * as React from 'react'
import { connect } from 'react-redux'
import { IssueType } from '../domain/Error'
import { License } from '../domain/License'
import Link from '../helper/link'
import { ApplicationState } from '../redux/ApplicationState'

interface OwnProps {
    active: IssueType
}

interface StateProps {
    license: License
    beta: boolean
}

type Props = OwnProps & StateProps

interface NavigationEntry {
    level: IssueType
    label: string
    stage: 'beta' | 'ga' | 'events' | 'notifications'
    route: string
    filterCheck?: (props: Props) => boolean
}

const navigationEntries: NavigationEntry[] = [
    { level: IssueType.ERROR, label: 'Errors / Exceptions', stage: 'ga', route: 'XhprofErrorBundle.Issues.errors' },
    { level: IssueType.SLOWSQL, label: 'Slow SQLs', stage: 'ga', route: 'XhprofErrorBundle.Issues.slowSql' },
    {
        level: IssueType.NON_FATALS,
        label: 'Deprecations / Warnings / Notices',
        stage: 'ga',
        route: 'XhprofErrorBundle.Issues.nonFatals',
        filterCheck: props => props.license.deprecationTracking && props.license.warningsAndNotices,
    },
    {
        level: IssueType.DEPRECATED,
        label: 'Deprecations',
        stage: 'ga',
        route: 'XhprofErrorBundle.Issues.deprecations',
        filterCheck: props => props.license.deprecationTracking && !props.license.warningsAndNotices,
    },
    { level: IssueType.RELEASE, label: 'Releases', stage: 'events', route: 'XhprofErrorBundle.Issues.release' },
    { level: IssueType.INCIDENT, label: 'Incidents', stage: 'notifications', route: 'XhprofErrorBundle.Issues.incident' },
    {
        level: IssueType.OBSERVATION,
        label: 'Observations',
        stage: 'ga',
        route: 'XhprofErrorBundle.Issues.observation',
        filterCheck: props => props.license.observations,
    },
]

class ErrorNavigationComponent extends React.Component<Props> {
    public render = () => {
        const { active, beta, license } = this.props

        const entries = navigationEntries.filter(entry => {
            if (entry.filterCheck && !entry.filterCheck(this.props)) {
                return false
            }
            switch (entry.stage) {
                case 'beta':
                    return beta
                case 'ga':
                    return true
                case 'events':
                    return license.events
                case 'notifications':
                    return license.notifications
            }
        })

        return (
            <ul className="nav nav-pills nav-pills-tideways">
                {entries.map(entry => (
                    <li className={active === entry.level ? 'active' : ''} key={entry.level}>
                        <Link route={entry.route}>
                            {entry.label}
                            {entry.stage === 'beta' && <span className="label label-outline-warning tw-ml-8">beta</span>}
                        </Link>
                    </li>
                ))}
            </ul>
        )
    }
}

export const ErrorNavigation = connect<StateProps, {}, OwnProps>(
    (state: ApplicationState): StateProps => ({
        beta: state.tidewaysContext.hasFeature('beta'),
        license: state.tidewaysContext.application.license,
    }),
)(ErrorNavigationComponent)
